import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore not typed yet
import { generateTilesOutsideOf } from 'layout-dnd-utils/geometry/tiling';
// @ts-ignore not typed yet
import { getElementBounds } from 'layout-dnd-utils/dom/bounds';
import NopeZone from 'InpageEditorUI/components/NopeZone';
import { getIsAnythingDragging } from '../redux/selectors/layoutSectionDndSelectors';
import { moduleInsertionNopeZoneSelector } from '../lib/inlineEditingUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const generateNopeZoneTiles = isAnythingDragging => {
  if (!isAnythingDragging) {
    return [];
  }
  const documentBounds = getElementBounds(document.documentElement, {
    applyScrollOffset: true
  });
  const boundsToCheck = [];
  const nopeZoneElements = Array.from(document.querySelectorAll(moduleInsertionNopeZoneSelector));
  if (nopeZoneElements.length > 0) {
    nopeZoneElements.forEach(nopeZoneElement => {
      boundsToCheck.push(getElementBounds(nopeZoneElement, {
        applyScrollOffset: true
      }));
    });
  }
  try {
    return generateTilesOutsideOf(documentBounds, boundsToCheck);
  } catch (err) {
    console.error('Error generating nope zone tiles: ', err);
    return [];
  }
};
function ModuleInsertionNopeZone() {
  const isAnythingDragging = useSelector(getIsAnythingDragging);
  const nopeZoneTiles = useMemo(() => generateNopeZoneTiles(isAnythingDragging), [isAnythingDragging]);
  return /*#__PURE__*/_jsx(View, {
    display: isAnythingDragging ? 'block' : 'none',
    children: nopeZoneTiles.map((tile, i) => /*#__PURE__*/_jsx(NopeZone, {
      top: tile.top,
      bottom: tile.bottom,
      right: tile.right,
      left: tile.left
    }, i))
  });
}
export default ModuleInsertionNopeZone;